import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast, { POSITION, type PluginOptions } from 'vue-toastification'
import VueSocialSharing from 'vue-social-sharing'
import { authPlugin } from '@clickadilla/components/plugins'
import vuetify from './plugins/vuetify/index'
import router from './router'
import { i18n } from './i18n'
import App from './App.vue'
import pixel from '@/plugins/pixel'
import sentry from '@/plugins/sentry'
import intercom from './plugins/intercom'
import tawk from '@/plugins/tawk'
import dashly from '@/plugins/dashly'
import crisp from '@/plugins/crisp'
import adServer from '@/plugins/ad-server'
import getsitecontrol from '@/plugins/getsitecontrol'
import { saveQueryParamsToCookie } from '@/cookie-queries'
import setQueryParamsToSessionStorage from '@/services/utils/set-query-params-to-session-storage'
import { authOptions, registerAuthInterceptors } from '@/plugins/auth'

import 'vue-toastification/dist/index.css'
import '@clickadilla/components/styles'
import '@/assets/scss/global.scss'

saveQueryParamsToCookie()
setQueryParamsToSessionStorage()

const app = createApp(App)
const pinia = createPinia()

const options: PluginOptions = {
  position: POSITION.TOP_CENTER,
  timeout: 2000
}

app.use(VueSocialSharing)
app.use(sentry, { router })
app.use(Toast, options)
app.use(intercom)
app.use(tawk)
app.use(dashly)
app.use(crisp)
app.use(adServer)
app.use(getsitecontrol)
app.use(pinia)
app.use(i18n)
registerAuthInterceptors(app)
app.use(authPlugin, authOptions)
app.use(pixel)
app.use(router)
app.use(vuetify)
app.mount('#app')
